import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class AudioTopic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        const listItm = (item, index) => {
            return (
                <div key={item.title} className={styles.listItem} style={{ marginRight: index === 4 ? 0 : 20 }}>
                    <a href={item.url} className={styles.fl}>
                        <img src={item.thumbnail} alt={item.title} />
                    </a>
                    <a href={item.url} className={styles.fr} title={item.title}>
                        <p>{item.title}</p>
                    </a>
                </div>
            );
        };

        return (
            <section className={styles.audioTopic} aria-label="精品有声">
                <div className={styles.title}>
                    <h2>精品有声</h2>
                </div>
                <div className={styles.list}>
                    {content &&
                        content.length &&
                        content.map((item, index) => {
                            return listItm(item, index);
                        })}
                </div>
            </section>
        );
    }
}

export default errorBoundary(AudioTopic);
